// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"1289":"fc34ea0b","1872":"fc34ea0b"}[chunkId] + ".chunk.css";
};